import { ControlledMenu, MenuItem, useMenuState } from '@szhsin/react-menu';
import React from 'react';
import { useTabsContext } from './util';
import { getLabel } from '@apia/util';
import { observer } from 'mobx-react-lite';

const ContextMenu = observer(
  ({
    anchorPoint,
    isOpen,
    onClose,
    targetId,
  }: {
    anchorPoint: {
      x: number;
      y: number;
    };
    isOpen: boolean;
    onClose: () => unknown;
    targetId: string;
  }) => {
    const [menuProps, toggleMenu] = useMenuState();
    React.useEffect(() => {
      toggleMenu(isOpen);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const controller = useTabsContext();

    const closeOthers = React.useCallback(() => {
      void controller.closeOthers(targetId);
    }, [controller, targetId]);

    const closeToLeft = React.useCallback(() => {
      void controller.closeToLeft(targetId);
    }, [controller, targetId]);

    const closeToRight = React.useCallback(() => {
      void controller.closeToRight(targetId);
    }, [controller, targetId]);

    const firstNonFixedTab = controller.tabsList.find(
      (current) => !current.state.isFixed,
    );

    let lastNonFixedTab: string | null = null;
    if (controller.tabsList)
      for (let i = controller.tabsList.length - 1; i >= 0; i--) {
        if (!controller.tabsList[i].state.isFixed) {
          lastNonFixedTab = controller.tabsList[i].id;
          break;
        }
      }

    const nonFixedTabsLength =
      controller.tabsList?.filter((current) => !current.state.isFixed).length ??
      0;

    return (
      <ControlledMenu
        {...menuProps}
        anchorPoint={anchorPoint}
        onClose={onClose}
        portal={{ target: document.getElementById('AppModals') as Element }}
      >
        {/* // No está bien implementado todavía
      <MenuItem
        onClick={React.useCallback(() => {
          controller.propsStore.updateField(targetId, { isFixed: true });
        }, [controller.propsStore, targetId])}
      >
        {window.LBL_FIX_TAB}
      </MenuItem> */}
        <MenuItem
          onClick={React.useCallback(() => {
            void controller.closeTab(targetId);
          }, [controller, targetId])}
        >
          {window.BTN_CLOSE}
        </MenuItem>
        <MenuItem
          onClick={React.useCallback(() => {
            void controller.closeAll();
          }, [controller])}
        >
          {getLabel('lblCloseAll').text}
        </MenuItem>
        {firstNonFixedTab?.id !== targetId && (
          <MenuItem onClick={closeToLeft}>
            {getLabel('lblCloseToLeft').text}
          </MenuItem>
        )}
        {lastNonFixedTab !== targetId && (
          <MenuItem onClick={closeToRight}>
            {getLabel('lblCloseToRight').text}
          </MenuItem>
        )}
        {nonFixedTabsLength > 1 && (
          <MenuItem onClick={closeOthers}>
            {getLabel('lblCloseOthers').text}
          </MenuItem>
        )}
      </ControlledMenu>
    );
  },
);

export default ContextMenu;
